import { setNoRouteAccess } from 'apps/user/actions/user';
import { AuthenticationLevel } from 'auth';

export function allowSuperuserOnly(nextState, replace, path, extras) {
  const { store } = extras;
  const { dispatch } = store;
  const { user } = store.getState();
  if (user.authenticationLevel === AuthenticationLevel.SUPERUSER) {
    return true;
  }

  dispatch(setNoRouteAccess());
  return false;
}
